module.exports = __webpack_public_path__ + "static/img/logo.e070d8e9.svg";